import React from 'react'
// Keep the existing geometry available before the async component arrives.
import './gallery.css'

let galleryModule
const loadGallery = () => {
  if (!galleryModule) {
    galleryModule = import('./gallery').catch(error => {
      galleryModule = null
      throw error
    })
  }
  return galleryModule
}

class DeferredGallery extends React.PureComponent {
  state = { Gallery: null }

  componentDidMount() {
    this.load()
    window.addEventListener('online', this.load)
  }

  componentWillUnmount() {
    this.unmounted = true
    window.removeEventListener('online', this.load)
    window.clearTimeout(this.retry)
  }

  load = () => {
    window.clearTimeout(this.retry)
    loadGallery().then(({ default: Gallery }) => {
      if (!this.unmounted) this.setState({ Gallery })
    }).catch(() => {
      // Recover from a transient chunk failure without changing the page UI.
      if (!this.unmounted) this.retry = window.setTimeout(this.load, 5000)
    })
  }

  render() {
    const { Gallery } = this.state
    return Gallery ? <Gallery {...this.props} /> : null
  }
}

export default DeferredGallery
